import Scroll from "../directives/scroll";
import { defineNuxtPlugin } from '#app'

/**
 * Plugin to register directives.
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('scroll', Scroll)
})
